import React from "react";
import { Helmet } from "react-helmet";
import TrainerCtaSection from "./components/TrainerCtaSection";
import TrainerExpertiseSection from "./components/TrainerExpertiseSection";
import TrainerHeaderSection from "./components/TrainerHeaderSection";
import TrainerJourneySection from "./components/TrainerJourneySection";
import TrainerLooksForSection from "./components/TrainerLooksForSection";
import TrainerWhySection from "./components/TrainerWhySection";
import SiteFooter from "../../components/layout/SiteFooter";

const BeACoach = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Be a Trainer</title>
      </Helmet>

      <TrainerHeaderSection />

      <TrainerWhySection />

      <TrainerExpertiseSection />

      <TrainerLooksForSection />

      <TrainerJourneySection />

      <TrainerCtaSection />

      <SiteFooter />
    </div>
  );
};

export default BeACoach;
